import { useState, useEffect, useRef } from 'react';
import { Link, useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import * as Yup from 'yup';
import axios from 'axios';
import Moment from 'moment';
// material
import { styled } from '@mui/material/styles';
import {
  Card,
  Table,
  Stack,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  CircularProgress,
  TableRow,
  TableHead,
  TableBody,
  TableCell,
  FormControl,
  Select,
  Icon,
  Container,
  Typography,
  MenuItem,
  TableContainer,
  TablePagination,
  TextField,
  Grid,
  IconButton,
  Toolbar,
  OutlinedInput,
  InputAdornment,
  useMediaQuery,
  Autocomplete,
} from '@mui/material';
import { Box } from '@mui/system';
import { ArrowBack, Delete } from '@mui/icons-material';
// import CopyToClipboard from 'react-copy-to-clipboard';
import { LoadingButton } from '@mui/lab';
import { useFormik, Form, FormikProvider } from 'formik';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import AddIcon from '@mui/icons-material/Add';
import ModeEditSharpIcon from '@mui/icons-material/ModeEditSharp';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useSelector } from 'react-redux';
import Filter from '../components/filters/Leads';
import ManagerFilter from '../components/filters/LeadFilterForManager';
import TelecallerFilter from '../components/filters/LeadFilterForTeleCaller';

// components
import Page from '../components/Page';
import Scrollbar from '../components/Scrollbar';
import Iconify from '../components/Iconify';
import Popup from '../components/popups/LeadStatusChange';
import Popup1 from '../components/popups/LeadDelete';
import ExcelUpload from '../components/popups/ExcelUpload';
import Export from '../components/filters/LeadExport';
import PageHeader from '../components/smallComponents/PageHeader';

const SearchStyle = styled(OutlinedInput)(({ theme }) => ({
  width: 240,
  transition: theme.transitions.create(['box-shadow', 'width'], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter,
  }),
  '&.Mui-focused': { width: 320, boxShadow: theme.customShadows.z8 },
  '& fieldset': {
    borderWidth: `1px !important`,
    borderColor: `${theme.palette.grey[500_32]} !important`,
  },
}));

const TableCellCustom = styled(TableCell)(({ theme }) => ({
  padding: 0,
  margin: 0,
}));

export default function CustomerLeads() {
  const [searchParams, setSearchParams] = useSearchParams();
  const customerId = searchParams.get('customerId');
  const { accType, role } = useSelector((state) => state.user.userInfo);

  const admin = accType === 'SUPER_ADMIN' || accType === 'SUB_ADMIN';
  const isLeadManager = role && role === 'SALES_MANAGER';
  const isTelecaller = role && role === 'SALES_STAFF';

  const navigate = useNavigate();

  const [selectedFilter, setSelectedFilter] = useState({});

  const matches = useMediaQuery('(max-width:600px)');
  const [leadData, setLeadData] = useState();
  const [name, setName] = useState('');
  const [pages, setPages] = useState(0);
  const [leadCount, setLeadCount] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [status, setStatus] = useState([]);
  const [isLoading1, setIsLoading1] = useState(false);
  const [statusFilter, setStatusFilter] = useState('all');
  const [customer, setCustomer] = useState({});

  const [selectedIndex, setSelectedIndex] = useState();
  const [size, setSize] = useState(10);
  const [options, setOptions] = useState({ size, page: 0, customer: customerId });
  const [open, setOpen] = useState(false);
  const [input, setInput] = useState(1);
  const [selectedStatus, setSelectedStatus] = useState({});

  // for add lead
  const [leadManagers, setLeadManagers] = useState([]);
  const [telecallers, setTelecallers] = useState([]);
  const [sources, setSources] = useState([]);
  const [categories, setCategories] = useState([]);
  const [leadManagersLoading, setLeadManagersLoading] = useState(true);
  const [telecallersLoading, setTelecallersLoading] = useState(false);
  const [sourcesLoading, setSourcesLoading] = useState(true);
  const [categoriesLoading, setCategoriesLoading] = useState(true);
  const [open1, setOpen1] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [open3, setOpen3] = useState(false);
  const [open4, setOpen4] = useState(false);
  const [isOtherSource, setIsOtherSource] = useState(false);

  // for export

  const leadSchema = Yup.object().shape({
    source: Yup.string().required('Source is required'),
    leadManager: Yup.string().required('Sales Manager is required'),
    category: Yup.string().required('Category is required'),
  });

  const formik = useFormik({
    initialValues: {
      source: '',
      leadManager: '',
      teleCaller: '',
      category: '',
      fullname: '',
      email: '',
      phone: '',
      address: '',
      otherSource: '',
      title: '',
    },
    validationSchema: leadSchema,
    onSubmit: async () => {
      try {
        const res = await axios.post(`${process.env.REACT_APP_API_URL}/lead/customer`, {
          ...values,
          customer: customerId,
        });
        if (!res.data.isError) {
          closeAddLeadModal(res.data.message);
          toast.success(res.data.message);
        } else {
          toast.error(res.data.message);
        }
        getLeads(options);
        resetForm();
      } catch (error) {
        console.log(error);
        toast.error(error.response.data.message);
      }
    },
  });
  const { errors, touched, values, isSubmitting, handleSubmit, getFieldProps, resetForm, setFieldValue } = formik;

  const getLeadManager = async () => {
    try {
      setLeadManagersLoading(true);
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/leadTeam/leadManager/list`);
      console.log('lead managers list', res.data.data.records);
      if (!res.data.isError) {
        if (res.data.data.records) {
          setLeadManagers(res.data.data.records);
        }
      }
      setLeadManagersLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const getTelecallers = async (managerId) => {
    try {
      setTelecallersLoading(true);
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/leadTeam/leadManager/telecallers/all`, {
        params: {
          managerId,
        },
      });
      console.log('telecallers list', res.data.data);
      if (!res.data.isError) {
        if (res.data.data.telecallers) {
          setTelecallers(res.data.data.telecallers);
        }
      }
      setTelecallersLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const getSources = async () => {
    try {
      setSourcesLoading(true);
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/leadSource/all/active`);
      console.log('sources list', res.data.data.status);
      if (!res.data.isError) {
        if (res.data.data.status) {
          setSources(res.data.data.status);
        }
      }
      setSourcesLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const getCategories = async () => {
    try {
      setCategoriesLoading(true);
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/leadCategory/all/active`);
      console.log('categories list', res.data.data.status);
      if (!res.data.isError) {
        if (res.data.data.status) {
          setCategories(res.data.data.status);
        }
      }
      setCategoriesLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const getStatus = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/leadStatus/all/active`);
      console.log('status list', res.data.data.status);
      if (!res.data.isError) {
        if (res.data.data.status) {
          setStatus(res.data.data.status);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleStatusChange = (event, item, index) => {
    console.log('item', item);
    if (`${item.statusData.name}` === event.target.value) {
      return;
    }
    const temp = status.filter((statusItem) => statusItem.name === event.target.value)[0];
    console.log(temp);
    setSelectedStatus(temp);
    setSelectedIndex(index);
  };

  const handleClose = (refresh = false, message = '') => {
    setSelectedIndex();
    if (refresh) {
      getLeads(options);
    }
    if (message) {
      toast(message);
    }
  };

  const openAddLeadModal = () => {
    setOpen(true);
  };

  const closeAddLeadModal = () => {
    setOpen(false);
    formik.resetForm();
  };

  const handlePageChange = (event, newPage) => {
    const temp = { ...options, page: newPage };
    setPages(newPage);
    setOptions(temp);
    setIsLoading(true);
    getLeads(temp);
  };

  const getLeads = (options) => {
    setIsLoading(true);
    axios
      .get(`${process.env.REACT_APP_API_URL}/lead/all`, {
        params: options,
      })
      .then((res) => {
        console.log('Leads', res);
        if (res.data.isError === false) {
          setIsLoading(false);
          setLeadCount(res.data.data.maxRecords);
          setLeadData(res.data.data.records);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  };

  const getLeadsWithoutLoading = (options) => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/lead/all`, {
        params: options,
      })
      .then((res) => {
        console.log('res', res);
        if (res.data.isError === false) {
          setLeadCount(res.data.data.maxRecords);
          setLeadData(res.data.data.records);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  };

  const getStatusColor1 = (statusName) => {
    const statusMapping = {
      Pending: '#eaea7e',
      Ongoing: '#FDDA0D',
      'Decision Pending': '#d1bc00',
      Interested: '#0b9703',
      'Not Interested': '#CC5500',
      Regret: '#EE4B2B',
    };
    return statusMapping[statusName] || '';
  };

  const exportLead = async (options) => {
    console.log(options);
    setIsLoading1(true);
    try {
      const res = await axios.post(`${process.env.REACT_APP_API_URL}/lead/export`, options);
      console.log('res', res);
      setIsLoading1(false);
      toast.success(res.data.message);
    } catch (error) {
      console.log(error);
      setIsLoading1(false);
      toast.success(error.response.data.message);
    }
  };

  const goToPage = () => {
    console.log('hi');
    if (input > Math.ceil(leadCount / size)) {
      return;
    }
    setInput(input > 0 ? input : 1);
    setPages(input - 1 >= 0 ? input - 1 : 0);
    const temp = { ...options, page: input - 1 };
    if (customerId) {
      temp.customer = customerId;
    }
    setOptions(temp);
    getLeads(temp);
  };

  const onSearch = (e) => {
    e.preventDefault();
    setName(e.target.value);
    const temp = { ...options, page: 0, fullname: e.target.value };
    if (customerId) {
      temp.customer = customerId;
    }
    setOptions(temp);
    setPages(0);
    getLeadsWithoutLoading(temp);
  };

  const handleStatusFilterChange = (event) => {
    if (event.target.value !== 'all') {
      const temp = { ...options, status: event.target.value };
      setOptions(temp);
      setIsLoading(true);
      getLeads(temp);
      setStatusFilter(event.target.value);
    } else {
      const temp = { ...options, status: '' };
      setOptions(temp);
      setIsLoading(true);
      getLeads(temp);
      setStatusFilter('all');
    }
  };

  const getCustomer = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/customer/one`, {
        params: {
          id: customerId,
        },
      });
      console.log(res.data.data);
      setCustomer(res.data.data.customer);
    } catch (error) {
      console.log(error);
    }
  };

  const applyFilters = (filter) => {
    console.log('filter', filter);
    const temp = { page: 0, size };
    if (customerId) {
      temp.customer = customerId;
    }
    if (filter.fullname.length) {
      temp.fullname = filter.fullname;
    }
    if (filter.email.length) {
      temp.email = filter.email.trim();
    }
    if (filter.phone.length) {
      temp.phone = filter.phone;
    }
    if (filter.leadManager) {
      temp.leadManager = filter.leadManager;
    }
    if (filter.teleCaller) {
      temp.teleCaller = filter.teleCaller;
    }
    if (filter.status.length) {
      temp.status = filter.status;
    }
    if (filter.category.length) {
      temp.category = filter.category;
    }
    if (filter.source.length) {
      temp.source = filter.source;
    }
    if (filter.startDate) {
      temp.startDate = filter.startDate;
    }
    if (filter.endDate) {
      temp.endDate = filter.endDate;
    }
    if (filter.customer) {
      temp.customer = filter.customer;
    }

    setOptions(temp);
    setPages(0);
    getLeads(temp);
    setSelectedFilter(filter);
  };

  useEffect(() => {
    if (customerId) {
      getCustomer();
    }
  }, [customerId]);

  useEffect(() => {
    getStatus();
    getLeads(options);
  }, []);

  useEffect(() => {
    if (open) {
      getLeadManager();
      getSources();
      getCategories();
    }
  }, [open]);

  useEffect(() => {
    if (values.leadManager) {
      getTelecallers(values.leadManager);
    } else {
      setTelecallers([]);
      formik.setFieldValue('teleCaller', '');
    }
  }, [values.leadManager]);

  useEffect(() => {
    const source = sources.find((source) => source.name === 'Other');
    if (source && values.source === source._id) {
      setIsOtherSource(true);
    } else {
      setIsOtherSource(false);
    }
  }, [values.source, sources]);

  return (
    <>
      <Page title="Customer Leads">
        {isLoading ? (
          <div
            style={{
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '50vh',
            }}
          >
            <CircularProgress />
          </div>
        ) : (
          <>
            {/* Add lead Dialog */}
            <Dialog open={open} onClose={closeAddLeadModal} fullScreen={matches}>
              <DialogTitle>Add RFQ</DialogTitle>
              <Box paddingBottom={'10px'} width={{ xs: '100%', sm: '600px' }}>
                <DialogContent paddingTop="20px">
                  <FormikProvider value={formik}>
                    <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                          <TextField fullWidth label="Fullname" value={customer.fullname} />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <TextField fullWidth label="Title" {...getFieldProps('title')} />
                        </Grid>

                        <Grid item xs={12} md={6}>
                          <TextField fullWidth label="Email" value={customer.email} />
                        </Grid>

                        <Grid item xs={12} md={6}>
                          <TextField fullWidth label="Phone" value={customer.phone} />
                        </Grid>

                        <Grid item xs={12}>
                          <TextField fullWidth multiline label="Address" value={customer.address} />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Autocomplete
                            id="asynchronous-demo"
                            fullWidth
                            open={open3}
                            onOpen={() => {
                              setOpen3(true);
                            }}
                            onClose={() => {
                              setOpen3(false);
                            }}
                            isOptionEqualToValue={(option, value) => option.name === value.name}
                            getOptionLabel={(option) => option.name}
                            options={sources}
                            loading={sourcesLoading}
                            onChange={(_, value) => {
                              if (value) {
                                formik.setFieldValue('source', value._id);
                              }
                            }}
                            renderInput={(params) => (
                              <TextField
                                required
                                {...params}
                                error={Boolean(touched.source && errors.source)}
                                helperText={touched.source && errors.source}
                                label="Source"
                                InputProps={{
                                  ...params.InputProps,
                                  endAdornment: (
                                    <>
                                      {sourcesLoading ? <CircularProgress color="inherit" size={20} /> : null}
                                      {params.InputProps.endAdornment}
                                    </>
                                  ),
                                }}
                              />
                            )}
                          />
                        </Grid>
                        {isOtherSource && (
                          <Grid item xs={12} md={6}>
                            <TextField fullWidth label="Other Source" {...getFieldProps('otherSource')} />
                          </Grid>
                        )}
                        <Grid item xs={12} md={6}>
                          <Autocomplete
                            id="asynchronous-demo"
                            fullWidth
                            open={open4}
                            onOpen={() => {
                              setOpen4(true);
                            }}
                            onClose={() => {
                              setOpen4(false);
                            }}
                            isOptionEqualToValue={(option, value) => option.name === value.name}
                            getOptionLabel={(option) => option.name}
                            options={categories}
                            loading={categoriesLoading}
                            onChange={(_, value) => {
                              if (value) {
                                formik.setFieldValue('category', value._id);
                              }
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                required
                                label="Category"
                                error={Boolean(touched.category && errors.category)}
                                helperText={touched.category && errors.category}
                                InputProps={{
                                  ...params.InputProps,
                                  endAdornment: (
                                    <>
                                      {categoriesLoading ? <CircularProgress color="inherit" size={20} /> : null}
                                      {params.InputProps.endAdornment}
                                    </>
                                  ),
                                }}
                              />
                            )}
                          />
                        </Grid>

                        <Grid item xs={12} md={6}>
                          <Autocomplete
                            id="asynchronous-demo"
                            fullWidth
                            open={open1}
                            onOpen={() => {
                              setOpen1(true);
                            }}
                            onClose={() => {
                              setOpen1(false);
                            }}
                            isOptionEqualToValue={(option, value) => option.fullname === value.fullname}
                            getOptionLabel={(option) => option.fullname}
                            options={leadManagers}
                            loading={leadManagersLoading}
                            onChange={(_, value) => {
                              if (value) {
                                formik.setFieldValue('leadManager', value._id);
                              }
                            }}
                            renderInput={(params) => (
                              <TextField
                                required
                                {...params}
                                error={Boolean(touched.leadManager && errors.leadManager)}
                                helperText={touched.leadManager && errors.leadManager}
                                label="Sales Manager"
                                InputProps={{
                                  ...params.InputProps,
                                  endAdornment: (
                                    <>
                                      {leadManagersLoading ? <CircularProgress color="inherit" size={20} /> : null}
                                      {params.InputProps.endAdornment}
                                    </>
                                  ),
                                }}
                              />
                            )}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Autocomplete
                            id="asynchronous-demo"
                            fullWidth
                            open={open2}
                            onOpen={() => {
                              setOpen2(true);
                            }}
                            onClose={() => {
                              setOpen2(false);
                            }}
                            disabled={!values.leadManager} // Disable Telecaller when LeadManager is not selected
                            isOptionEqualToValue={(option, value) => option.fullname === value.fullname}
                            getOptionLabel={(option) => option.fullname}
                            options={telecallers}
                            loading={telecallersLoading}
                            onChange={(_, value) => {
                              if (value) {
                                formik.setFieldValue('teleCaller', value._id);
                              }
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                error={Boolean(touched.teleCaller && errors.teleCaller)}
                                helperText={touched.teleCaller && errors.teleCaller}
                                label="Sales Staff"
                                InputProps={{
                                  ...params.InputProps,
                                  endAdornment: (
                                    <>
                                      {telecallersLoading ? <CircularProgress color="inherit" size={20} /> : null}
                                      {params.InputProps.endAdornment}
                                    </>
                                  ),
                                }}
                              />
                            )}
                          />
                        </Grid>
                      </Grid>
                      <Stack direction={'row'} justifyContent="flex-end" paddingTop="20px">
                        <Button onClick={closeAddLeadModal}>Cancel</Button>
                        <LoadingButton type="submit" loading={isSubmitting}>
                          Add RFQ
                        </LoadingButton>
                      </Stack>
                    </Form>
                  </FormikProvider>
                </DialogContent>
              </Box>
            </Dialog>
            {/* Add lead dialog end */}

            {/* export leads modal  */}

            <Container maxWidth="xl">
              <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ my: 1 }}>
                <PageHeader title="Customer Leads" />
                <Stack direction="row" justifyContent="end" alignItems={'center'} spacing={5}>
                  <Stack direction="row" justifyContent="end" alignItems={'center'} spacing={1}>
                    <Export />
                    <LoadingButton
                      endIcon={<Iconify icon="ph:export-bold" />}
                      variant="outlined"
                      color="primary"
                      onClick={() => exportLead(options)}
                      loading={isLoading1}
                      size="small"
                    >
                      Export
                    </LoadingButton>
                  </Stack>
                </Stack>
              </Stack>
              {admin && <Filter applyFilters={applyFilters} filterValues={options} />}
              {!!isLeadManager && <ManagerFilter applyFilters={applyFilters} />}
              {!!isTelecaller && <TelecallerFilter applyFilters={applyFilters} />}
              <Card>
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                  {/* <Stack direction="row" spacing={2} padding={2}>
                    <TextField
                      size="small"
                      style={{ maxWidth: '100px', maxHeight: '35px' }}
                      type="number"
                      component="div"
                      label="Go to"
                      value={input}
                      onInput={(e) => setInput(e.target.value)}
                    />
                    <Button variant="contained" onClick={goToPage} style={{ maxHeight: '35px' }}>
                      Go
                    </Button>
                  </Stack> */}
                  <Stack direction="row" spacing={2} padding={2}>
                    <SearchStyle
                      value={name}
                      onChange={onSearch}
                      placeholder="Search lead..."
                      startAdornment={
                        <InputAdornment position="start">
                          <Iconify icon="eva:search-fill" sx={{ color: 'text.disabled', width: 20, height: 20 }} />
                        </InputAdornment>
                      }
                    />
                    <TextField
                      select
                      value={statusFilter}
                      label="Status"
                      onChange={(e) => handleStatusFilterChange(e)}
                      sx={{ width: '150px', height: '100%' }}
                    >
                      <MenuItem value={'all'}>
                        <Stack direction="row" spacing={0.5} alignItems="center">
                          <Box
                            sx={{
                              width: 14,
                              height: 14,
                              backgroundColor: getStatusColor1('all'),
                              borderRadius: '50%',
                            }}
                          />
                          <Box>All</Box>
                        </Stack>
                      </MenuItem>
                      {status.map((item, index) => (
                        <MenuItem value={item._id} key={index}>
                          <Stack direction="row" key={index} spacing={0.5} alignItems="center">
                            <Box
                              sx={{
                                width: 14,
                                height: 14,
                                backgroundColor: getStatusColor1(item.name),
                                borderRadius: '50%',
                              }}
                            />
                            <Box>{item.name}</Box>
                          </Stack>
                        </MenuItem>
                      ))}
                    </TextField>
                  </Stack>
                  <Stack padding={1} direction="row" justifyContent="flex-end" spacing={2} alignItems="center">
                    {admin && (
                      <Button startIcon={<AddIcon />} variant="contained" onClick={openAddLeadModal}>
                        Add RFQ
                      </Button>
                    )}
                  </Stack>
                </Stack>

                <Stack direction="row" justifyContent="space-between" alignItems="center" padding={2}>
                  <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                    Customer: {customer?.fullname && customer?.fullname}
                  </Typography>
                </Stack>

                <Scrollbar>
                  <TableContainer sx={{ minWidth: 800 }}>
                    <Table size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell colSpan={2}>Sl No</TableCell>
                          <TableCell>Date</TableCell>
                          <TableCell>Category</TableCell>
                          <TableCell>Fullname</TableCell>
                          <TableCell>Title</TableCell>
                          <TableCell>Phone</TableCell>
                          <TableCell>Email</TableCell>
                          {/* <TableCell>Customer</TableCell> */}
                          <TableCell>Source</TableCell>
                          <TableCell>Status</TableCell>
                          <TableCell>Sales Staff</TableCell>
                          <TableCell>Manager</TableCell>
                          <TableCell>Action</TableCell>
                          {/* <TableCell>Actions</TableCell> */}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {leadData?.map((item, id) => (
                          <TableRow key={id} sx={{ '&:hover': { backgroundColor: '#f5f5f5' } }}>
                            <TableCellCustom>
                              <Box
                                sx={{
                                  width: 14,
                                  height: 34,
                                  backgroundColor: getStatusColor1(item?.statusData?.name),
                                  padding: 0,
                                  margin: 0,
                                }}
                              />
                            </TableCellCustom>
                            <TableCell>{pages * size + (id + 1)}</TableCell>
                            <TableCell>{Moment(item.createdAt).format('DD/MM/YYYY')}</TableCell>
                            <TableCell>{item.categoryData.name}</TableCell>
                            <TableCell>{item.fullname}</TableCell>
                            <TableCell>{item.title}</TableCell>
                            <TableCell>{item.phone}</TableCell>
                            <TableCell>{item.email}</TableCell>
                            {/* <TableCell>{item.customer ? 'Yes' : 'No'}</TableCell> */}
                            <TableCell>{item?.sourceData?.name}</TableCell>
                            <TableCell>
                              <FormControl sx={{ minWidth: 100 }}>
                                <Select
                                  size="small"
                                  value={item?.statusData?.name}
                                  onChange={(e) => handleStatusChange(e, item, id)}
                                >
                                  {status &&
                                    status?.map((item) => (
                                      <MenuItem key={item._id} value={item.name}>
                                        <Stack direction="row" spacing={0.5} alignItems="center">
                                          <Box
                                            sx={{
                                              width: 14,
                                              height: 14,
                                              backgroundColor: getStatusColor1(item.name),
                                              borderRadius: '50%',
                                            }}
                                          />
                                          <Box>{item.name}</Box>
                                        </Stack>
                                      </MenuItem>
                                    ))}
                                </Select>
                                {selectedIndex === id && (
                                  <Popup item={item} handleClose={handleClose} status={selectedStatus} />
                                )}
                              </FormControl>
                            </TableCell>
                            <TableCell>
                              <Typography
                                sx={{ cursor: 'pointer' }}
                                onClick={() => navigate(`/dashboard/employees/view/${item?.telecallerData?._id}`)}
                              >
                                {item?.telecallerData?.fullname}
                              </Typography>
                            </TableCell>
                            <TableCell>
                              <Typography
                                sx={{ cursor: 'pointer' }}
                                onClick={() => navigate(`/dashboard/employees/view/${item?.managerData?._id}`)}
                              >
                                {item?.managerData?.fullname}
                              </Typography>
                            </TableCell>
                            <TableCell>
                              <Stack direction="row" spacing={1}>
                                <Link to={`/dashboard/crm/lead/view/${item._id}`}>
                                  <Button
                                    variant="contained"
                                    startIcon={<RemoveRedEyeIcon />}
                                    size="small"
                                    color="viewButton"
                                  >
                                    View
                                  </Button>
                                </Link>
                              </Stack>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Scrollbar>
                <TablePagination
                  rowsPerPageOptions={[10, 20, 30]}
                  onRowsPerPageChange={(e) => {
                    setSize(e.target.value);
                    const temp = { ...options, size: e.target.value, page: 0 };
                    if (customerId) temp.customer = customerId;
                    setPages(0);
                    setOptions(temp);
                    getLeads(temp);
                  }}
                  component={'div'}
                  count={leadCount}
                  showFirstButton
                  showLastButton
                  onPageChange={handlePageChange}
                  rowsPerPage={size}
                  page={pages}
                />
              </Card>
            </Container>
          </>
        )}
      </Page>
    </>
  );
}
